<script lang="ts">
	import { AVAILABLE_MODELS } from 'src/constants/models';
	import Select from '@astlai/common/Select.svelte';

	interface Props {
		model: string;
		label?: string;
		onchange?: (v: string) => void;
	}

	let { model = $bindable(), onchange = () => {}, label }: Props = $props();

	const grouped = Object.entries(
		AVAILABLE_MODELS.reduce(
			(acc, val) => ({ ...acc, [val.vendor]: [...(acc[val.vendor] || []), val] }),
			{} as Record<string, { key: string; name: string; vendor: string }[]>
		)
	);
</script>

<label>
	{#if label}
		<span>{label}</span>
	{/if}
	<Select compact={!label} {onchange} bind:value={model}>
		{#each grouped as [vendor, group] (vendor)}
			<optgroup label={vendor}>
				{#each group as model (model.key)}
					<option value={model.key}>{model.name}</option>
				{/each}
			</optgroup>
		{/each}
	</Select>
</label>
